import ScrollDir from "./plugins/scrollDir";
import ScrollObserver from "./plugins/scrollObserver";

const [w,d,mq] = [window,document,window.matchMedia('(max-width: 900px)')];

class hideFixbtn extends ScrollObserver {
  constructor(elm,opt) {
    opt = Object.assign({
      rootMargin: "0% 0px 0%", // ビューポートの中心を判定基準にする
    }, opt);
    super(opt);
    this.btn = elm;
  }

  observeElement (trig) {
    this.observer = new IntersectionObserver( this.callback.bind(this), this.opt);
    this.observer.observe( trig );
  }

  intersectIn () {
    this.btn.classList.add('hidden');
  }

  intersectOut () {
    this.btn.classList.remove('hidden');
  }

}

class service_mtg {
  init(){
    this.fixnav = d.querySelector('[data-plugin="fixnav"]');
    this.trigger = d.querySelector('.formlist__wrap');
    new hideFixbtn(this.fixnav).observeElement(this.trigger);
    if( mq.matches ) this.scrolltrigger();
  }
  
  scrolltrigger() {
    d.addEventListener('Scroll.scrollUp', () => {
      this.fixnav.classList.remove('js-scroll-down');
      this.fixnav.classList.add('js-scroll-up');
    });
    d.addEventListener('Scroll.scrollDown', () => {
      this.fixnav.classList.remove('js-scroll-up');
      this.fixnav.classList.add('js-scroll-down');
    });
  }
}

$(() => {
  const lp = new service_mtg();
  new ScrollDir();
  d.addEventListener('loadHtml', () => lp.init() );
});
